import { Dropdown } from 'legacy/lut/library/dropdown'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { selectJBPSettings } from '../../../../../../../../../features/partner360/jbpSettings'
import { TRANSLATION_KEYS } from '../../../../translations/TRANSLATION_KEYS'

interface IProps {
  value: number
  onChange: (value: string) => void
  className?: string
}

export const ComposedReportFYearSelect = ({ value, onChange, className }: IProps) => {
  const { reportsFYears } = useSelector(selectJBPSettings)

  const fYearsCrud = useMemo(() => {
    return new Crud({
      fetcher: new Static(reportsFYears.map((year) => ({ label: year, value: year }))),
      keyField: 'value',
    })
  }, [reportsFYears])

  return (
    <Dropdown
      classes={{
        controlClasses: {
          root: className,
        },
      }}
      source={fYearsCrud}
      caption="label"
      value={value}
      onChange={onChange}
      translation={TRANSLATION_KEYS.fYearField}
    />
  )
}
